import React, { useEffect } from "react";
import Banner from "./Menu/Banner";
import MenuCategories from "./Menu/MenuCategories";

const Menu = () => {
  useEffect(() => {
    // Ensure scroll + body state is clean when Menu loads
    document.body.style.overflow = "auto";
    window.scrollTo(0, 0);

    return () => {
      // Cleanup when leaving Menu page
      document.body.style.overflow = "auto";
    };
  }, []);


  useEffect(() => {
  console.log("MENU MOUNTED");
  return () => console.log("MENU UNMOUNTED");
}, []);

  return (
    <main className="menu-page">
      {/* PAGE TITLE */}
      <section className="menu-header text-center">
        <Banner />
        {/* <h1 className="menu-heading">Our Menus</h1>
        <p className="menu-subheading">
          Explore our curated menus or build your own custom menu
        </p> */}
      </section>

      {/* MENU LIST */}
      <section className="menu-content">
        <MenuCategories />
      </section>
    </main>
  );
};

export default Menu;